import { render } from "./Add.vue?vue&type=template&id=62e7194b"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import exportComponent from "/var/jenkins_home/workspace/fbdnextui_staging-uk-v3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__